import * as braze from '@braze/web-sdk';
import md5 from 'crypto-js/md5';

import type { User } from '@montugroup/circuit-shared/types/user';

import settings from '../constants/constants';

// https://www.braze.com/docs/developer_guide/platform_integration_guides/web/analytics/setting_custom_attributes/
export function updateUserAttributes({ user }: { user: User }) {
  const brazeUser = braze.getUser();
  if (!brazeUser) {
    return;
  }

  brazeUser.setFirstName(user.firstName ?? '');
  brazeUser.setEmail(user.email ?? '');
}

type BrazeInitOptions = {
  options?: Omit<braze.InitializationOptions, 'baseUrl'>;
  contentCardsSubscriber?: (events: braze.ContentCards) => void;
};

export function changeUser(email: User['email']) {
  const identifier = md5(email.toLowerCase().trim()).toString();
  braze.changeUser(identifier);
}

// https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#step-2-initialize-braze
export function init({ contentCardsSubscriber }: BrazeInitOptions = {}) {
  braze.initialize(settings.brazeApiKey, {
    baseUrl: settings.brazeBaseUrl,
  });
  braze.requestPushPermission();
  braze.automaticallyShowInAppMessages();

  if (contentCardsSubscriber) {
    braze.subscribeToContentCardsUpdates(contentCardsSubscriber);
    braze.requestContentCardsRefresh();
  }

  braze.openSession();
}
